import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TabEnabledMixin from '../../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './TravelBookingForm.html?raw';
//import { _TabEnabledMixin } from "../../../../moreCore/_loadingHelpers/Tabbing";
import { BookingTypes, BookingType, SpecificationsCollector, SpecificationsIndividual, vt_travel, VT_Travel_Types, AddressSelectOptions, AddressCallbackFunctions, BookedForLoadData, TravelBookingLoadData, AddressRef, BookedForTypes, TravelBookingSaveData, AdditionalFormSaveData, ProjectRef, BookedForTranslations } from "../TravelBookingListTypes";
import { VAM2types } from "../../../_loadingHelpers/VAMv2Types";
import Edit from '../../../../moreCore/UI/Edit/Edit';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import AddressHintbox from '../AddressHintbox/AddressHintbox';
import "../AddressHintbox/AddressHintbox";
import ExpandableSection from '../../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../../moreCore/UI/Container/ExpandableSectionTypes";
import AdditionalInfoWidget from './Forms/Widgets/AdditionalInfo/AdditionalInfoWidget';
import TransportInventoryTable from './Forms/Widgets/TransportInventory/TransportInventoryTable';
import BookedForTable from './Forms/Widgets/BookedFor/BookedForTable';
import CollectionForm from './Forms/Collection/CollectionForm';
import TrainBookingForm from './Forms/TrainBooking/TrainBookingForm';
import PlaneBookingForm from './Forms/PlaneBooking/PlaneBookingForm';
import TransferBookingForm from './Forms/TransferBooking/TransferBookingForm';
import AccommodationBookingForm from './Forms/AccommodationBooking/AccommodationBookingForm';
import TransportBookingForm from './Forms/TransportBooking/TransportBookingForm';
import TravelInfoForm from './Forms/TravelInfo/TravelInfoForm';
import "../../../EMail/emailFormStandalone";
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import emailForm from '../../../EMail/emailForm';
import { AddressWizardTypes, AddressClassnames } from "../../../AddressWizard/AddressWizardTypes";

class TravelBookingForm extends compose(_WidgetBaseSP, _TabEnabledMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private originalData: TravelBookingLoadData;

    private entity: TravelBookingLoadData;
    private project: VAM2types.EvProjectEntity_Extended;

    private projectEdit: MdsLax<InstanceType<typeof Edit>>;
    private inputDescription: MdsLax<InstanceType<typeof Edit>>;
    private inputBookingNo: MdsLax<InstanceType<typeof Edit>>;

    private additionalForm;
    private additionalFormContainer: HTMLDivElement;

    private additionalInfoWidget: MdsLax<InstanceType<typeof AdditionalInfoWidget>>;
    private additionalInfoContainer: HTMLDivElement;

    private bookedForExpandableSection: MdsLax<InstanceType<typeof ExpandableSection>>;
    private table: MdsLax<InstanceType<typeof BookedForTable>> | MdsLax<InstanceType<typeof TransportInventoryTable>>;
    private tableContainer: HTMLDivElement;

    private addressHintbox: MdsLax<InstanceType<typeof AddressHintbox>>;

    private isNew: boolean;
    private bookingType: VT_Travel_Types;

    private isDirty: boolean = false;
    private tableIsDirty: boolean = false;

    private hintboxCarrier: MdsLax<InstanceType<typeof HintBox>>;
    private hintboxCarrierContactPerson: MdsLax<InstanceType<typeof HintBox>>;

    private newMailForm: MdsLax<InstanceType<typeof emailForm>>;
    //private newMailFormReciverMail: string;
    private mailDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private carrierLabel: string = "TravelBooking_Label_Carrier";
    private carrierCpLabel: string = "TravelBookingForm_Label_CarrierContactPerson";


    constructor(type: string) {
        super(...(arguments as unknown as []));
        var bookingTypes = Object.keys(BookingTypes);
        var isValidBookingType = bookingTypes.indexOf(type) > -1;

        if (isValidBookingType) {
            this.setBookingType(type);
        } else {
            console.error("Not a valid booking type");
        }

        if (this.bookingType === "accommodation_bookings") {
            this.carrierLabel = this.translate("TravelBooking_Label_Hotel");
            this.carrierCpLabel = this.translate("TravelBooking_Label_HotelContactPerson");
        }
    }

    private onInputChange(e): void {
        this.emit("change");
    }



    getData() {
        var additionalFormData = this.additionalForm.getData() as AdditionalFormSaveData;
        var additionalInfoFormData = this.additionalInfoWidget.getData();

        //General Form Data
        var formData: TravelBookingSaveData = {
            ID: this.entity ? this.entity.ID : String(Math.round(Math.random() * 100000)),
            projectID: this.project.ID,
            description: this.inputDescription.getValue(),
            isNew: this.isNew,
            bookingType: this.bookingType,
            bookedFor: (this.bookingType !== "transport_booking") ? this.table.getData() as EntityStoreData<BookedForLoadData> : null,
            note: additionalInfoFormData.note,
            note_internal_use: additionalInfoFormData.note_internal_use,
            responsibleId: additionalInfoFormData.responsibleId,
            booking_no: this.inputBookingNo.getValue(),
            carrier: this.hintboxCarrier.getValue("value"),
            carrierCP: this.hintboxCarrierContactPerson.getValue("value")
        };
        if (this.bookingType !== "transport_booking" && this.bookingType !== "travel_info_booking") {
            formData.bookingCollectorId = additionalInfoFormData.bookingCollectorId;
        }

        //Additional Form Data
        switch (this.bookingType) {
            case "travel_booking_collection":
            case "vt_travel_collection":
            case "flight_booking_collection":
                break;
            case "train_bookings":
            case "flight_bookings":
            case "transfer_bookings":
                formData.locationStart = additionalFormData.locationStart;
                formData.locationEnd = additionalFormData.locationEnd;
                formData.date_forerun = additionalFormData.date_forerun;
                formData.duration_forerun = additionalFormData.duration_forerun;
                formData.date_start = additionalFormData.date_start;
                formData.duration = additionalFormData.duration;
                formData.date_end = additionalFormData.date_end;
                formData.transportation_code = additionalFormData.transportation_code;
                formData.note_2 = additionalFormData.note_2;

                if (this.bookingType === "transfer_bookings") {
                    formData.transferVehicleRef = additionalFormData.transferVehicleRef;
                }
                break;
            case "accommodation_bookings":
                formData.date_start = additionalFormData.date_start;
                formData.date_end = additionalFormData.date_end;
                formData.qty_nights = additionalFormData.qty_nights;
                formData.note_2 = additionalFormData.note_2;
                break;
            case "travel_info_booking":
            case "transport_booking":
                formData.date_start = additionalFormData.date_start;
                formData.duration = additionalFormData.duration;
                formData.date_end = additionalFormData.date_end;
                formData.alternativeTimeId = additionalFormData.alternativeTimeId;

                if (this.bookingType === "transport_booking") {
                    formData.note_2 = additionalFormData.note_2;
                }
                break;
        }

        //Additional Info Widget
        if (this.bookingType !== "travel_info_booking") {
            formData.date_reminder = additionalInfoFormData.date_reminder;
        }

        if (!formData.date_forerun) {
            delete formData.date_forerun;
        }

        if (!formData.date_start) {
            delete formData.date_start;
        }

        if (!formData.date_end) {
            delete formData.date_end;
        }

        if (!formData.date_reminder) {
            delete formData.date_reminder;
        }

        if (!formData.bookedFor) {
            delete formData.bookedFor;
        }

        return formData;
    }

    getTabTitle(customTitle?: string): string {
        var newTitle = "";

        if (customTitle) {
            newTitle = customTitle;
        } else if (this.isNew || !this.entity) {
            newTitle = `${this.translate("General_New")}: ${this.translate(BookingTypes[this.bookingType])}`;
        } else {
            newTitle = `${this.entity.gDisp_1}`;
        }
        return newTitle;
    }

    private setIsNew(isNew: boolean) {
        this.isNew = isNew;
    }

    private setBookingType(bookingType) {
        this.bookingType = bookingType;
    }



    private setProject(project: VAM2types.EvProjectEntity_Extended) {
        this.project = project;
        this.projectEdit.setValue(this.project.gDisp_1)
    }

    loadData(bookingId: string, type: string) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_ProjectWizard_GetVtTravelById", { id: bookingId, type: type }, lang.hitch(this, this._onLoadResponse), lang.hitch(this, this._onErrorResponse));
    }

    private createNewTable(): void {
        if (this.bookingType === "transport_booking") {
            this.table = new TransportInventoryTable();
            this.table.createTable(this.project, BookedForTypes[this.bookingType]);
        } else {
            this.table = new BookedForTable();
            this.table.createTable(this.project, BookedForTypes[this.bookingType]);
        }
        this.table.on("change", lang.hitch(this, this._checkStoreDirty));
        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);
        this.bookedForExpandableSection.setMarking(this.table.hasEntities() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    private _onLoadResponse(response) {
        this.originalData = response;

        this.entity = response;
        this.isNew = false;
        this._resetDirty();

        //this.store.setup(this.entity.EL_ht_travel_address_vt_travel);
        //this.setupTable();

        this.table.setEntity(this.entity);
        this._setExpanderMarking();

        this.setupAdditionalForm(this.entity);
        this.setupAdditionalInfoWidget(this.entity);

        this.inputDescription.setValue(this.entity.description, true);
        this.inputBookingNo.setValue(this.entity.booking_no, true);
        this.hintboxCarrier.setValue(this.entity.ref_executive_company, true);
        this._onChangeCarrier(null, true);

        this.hintboxCarrierContactPerson.setValue(this.entity.ref_executive_contactperson, true);
        this._onChangeCarrierContactPerson(null, true);

        this.requestTabRename(this.getTabTitle());

        if (this.hasUserRole("Travel_Delete")) {
            this.createDefaultButton("delete", lang.hitch(this, this._onClickDelete));
        }

        if (this.hasUserRole("Travel_Read")) {
            this.createDefaultButton("rollback", lang.hitch(this, this._rollback), false);
            this.createDefaultButton("reload", lang.hitch(this, this._reload), true);
        }

        if ((this.bookingType === "transfer_bookings" ||
            this.bookingType === "transport_booking" ||
            this.bookingType === "train_bookings" ||
            this.bookingType === "flight_bookings" ||
            this.bookingType === "travel_info_booking")
            && this.hasUserRole("Travel_Create")) {
            this.createMenuGroup({ label: this.translate("General_Label_Copy"), name: "copy", hasNextLevel: true, iconClass: "fas fa-copy" });

            this.requestContextButton({
                label: this.translate("TravelBookingForm_Label_CopyLocation"),
                groupName: "copy",
                name: "locationSwitched",
                callback: lang.hitch(this, this._onClickCopy, "ReverseLocation"),
                enabled: true,
                permanent: false,
                placement: "primarymenu",
                tooltip: this.translate("TravelBookingForm_Tooltip_ReverseLocation"),
                iconClass: "fas fa-repeat"
            });

            this.requestContextButton({
                label: this.translate("TravelBookingForm_Label_CopyLocation"),
                groupName: "copy",
                name: "location",
                callback: lang.hitch(this, this._onClickCopy, "SaveLocation"),
                enabled: true,
                permanent: false,
                placement: "primarymenu",
                tooltip: this.translate("TravelBookingForm_Tooltip_SaveLocation"),
                iconClass: "fas fa-copy"
            });

            this.requestContextButton({
                label: this.translate("TravelBookingForm_Label_CopyLocation"),
                groupName: "copy",
                name: "noLocation",
                callback: lang.hitch(this, this._onClickCopy, ""),
                enabled: true,
                permanent: false,
                placement: "primarymenu",
                tooltip: this.translate("TravelBookingForm_Tooltip_NoLocation"),
                iconClass: "fas fa-trash warningTXT"
            });
        }

        this.StandbyStop();
    }

    private _onClickCopy(mode: "ReverseLocation" | "SaveLocation" | "", e: MouseEvent) {
        this.StandbyStart();

        let payload = {
            ID: this.entity.ID,
            Classname: this.entity.Classname,
            mode: mode
        }

        this.RequestManager.callfunction("Webtool_API__TravelBookingForm_CopyTransferBooking", payload, lang.hitch(this, this._onCopyResponse), lang.hitch(this, this._onCopyError))
    }

    private _onCopyResponse(response) {
        this.StandbyStop();

        this.showToast(this.translate("TravelBookingForm_Success_Copy"), "fas fa-check");
    }

    private _onCopyError(error) {
        this.StandbyStop();
        console.error(error);
        this.showToast(this.translate("TravelBookingForm_Error_Copy"), "fas fa-exclamation-triangle");
    }

    private _setExpanderMarking() {
        this.bookedForExpandableSection.setMarking(this.table.hasEntities() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    private _rollback(): void {
        this._onLoadResponse(this.originalData);
        this._resetDirty();
    }

    private _reload(): void {
        this.loadData(this.entity.ID, this.bookingType);
    }

    private _onClickDelete(e: Event): void {
        var deleteCollectorRefs: boolean = false;

        if (this.bookingType === "flight_booking_collection" ||
            this.bookingType === "travel_booking_collection" ||
            this.bookingType === "vt_travel_collection") {
            if (!this.additionalForm.isStoreEmpty()) {
                let dlgConfirm = new GenericDialog();
                dlgConfirm.show(
                    this.translate("Es sind noch andere Buchungen dieser Sammelbuchung zugeordnet. Sollen diese gelöscht werden?"),
                    this.translate("General_Delete"),
                    "",
                    "",
                    "yesno",
                    lang.hitch(this, this._deleteCollectionRefsCallback, deleteCollectorRefs)
                );
            } else {
                this._deleteTravelBooking();
            }
        } else {
            this._deleteTravelBooking();
        }
    }


    private _deleteTravelBooking(deleteCollectorRefs?: boolean) {
        if (this.table.isStoreEmpty()) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(
                this.translate("General_ConfirmDeleteMessage"),
                this.translate("General_Delete"),
                "",
                "",
                "okcancel",
                lang.hitch(this, this._confirmDeleteCallback, deleteCollectorRefs)
            );
        } else {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(
                this.translate("Es sind noch Reisebuchungen verknüpft. Trotzdem löschen?"),
                this.translate("General_Delete"),
                "",
                "",
                "okcancel",
                lang.hitch(this, this._confirmDeleteCallback, deleteCollectorRefs)
            );
        }
    }


    private _deleteCollectionRefsCallback(deleteCollectionsRefs: boolean, response: number): void {
        if (response === 2) {
            deleteCollectionsRefs = true;
        }

        this._deleteTravelBooking(deleteCollectionsRefs);
    }

    private _confirmDeleteCallback(deleteCollectorRefs: boolean, response: number): void {
        if (response === 1) {
            this.RequestManager.callfunction("Webtool_API_TravelBookingForm_Delete",
                { ID: this.entity.ID, type: this.bookingType, deleteCollectorRefs: deleteCollectorRefs },
                lang.hitch(this, this._onDeleteRepsone),
                lang.hitch(this, this._onDeleteError));
        }
    }

    private _onDeleteRepsone(response) {
        console.log(response);
        this.emit("deleted");
        this.closeTab();
    }

    private _onDeleteError(error) {
        console.error(error)
    }

    private _onErrorResponse(response) {
        this.StandbyStop();
        console.error(response);
    }

    private placeAdditionalForm() {
        this.UiModder.domConstruct.place(this.additionalForm.domNode, this.additionalFormContainer);
    }

    private setupAdditionalForm(entity?) {
        if (entity) {
            this.additionalForm.prepareData(entity);
        } else {
            this.additionalForm.prepareData();
        }
        this.additionalForm.on("change", lang.hitch(this, this.emit, "change"));
        this.placeAdditionalForm();
        this.additionalForm.startup();
    }

    private placeAdditionalInfoWidget() {
        this.UiModder.domConstruct.place(this.additionalInfoWidget.domNode, this.additionalInfoContainer);
    }

    private setupAdditionalInfoWidget(entity?) {
        if (entity) {
            this.additionalInfoWidget.prepareData(entity);
        } else {
            this.additionalInfoWidget.prepareData();
        }
        this.placeAdditionalInfoWidget();
    }

    setupForm(isNew: boolean, bookingType: string, project: VAM2types.EvProjectEntity_Extended, id?: string): void {
        this.setProject(project);

        this._createAdditionalInfoWidget();


        switch (this.bookingType) {
            case "flight_booking_collection":
            case "vt_travel_collection":
            case "travel_booking_collection":
                this.additionalForm = new CollectionForm();
                this.additionalForm.on("newBookingForm", lang.hitch(this, this._emitNewBookingForm));
                break;
            case "train_bookings":
                this.additionalForm = new TrainBookingForm(this.bookingType);
                break;
            case "flight_bookings":
                this.additionalForm = new PlaneBookingForm(this.bookingType);
                break;
            case "transfer_bookings":
                this.additionalForm = new TransferBookingForm(this.bookingType);
                break;
            case "accommodation_bookings":
                this.additionalForm = new AccommodationBookingForm();
                break;
            case "transport_booking":
                this.additionalForm = new TransportBookingForm();
                break;
            case "travel_info_booking":
                this.additionalForm = new TravelInfoForm();
                break;
        }


        this.createNewTable();
        this.setIsNew(isNew);
        if (!this.isNew && id) {
            this.loadData(id, this.bookingType);
        } else {
            this.setupAdditionalForm();
            this.setupAdditionalInfoWidget();
        }
        if (this.isEmbeddedInTab) {
            this.createDefaultButton("save", lang.hitch(this, this._onSaveButtonClick));
        }

    }

    private _emitNewBookingForm(entity) {
        console.log(entity);
        this.emit("newBookingForm", entity);
    }

    private _createAdditionalInfoWidget(): void {
        this.additionalInfoWidget = new AdditionalInfoWidget(this.bookingType, this.project.ID);
        this.additionalInfoWidget.on("change", lang.hitch(this, this.emit, "change"));
    }



    private getAddressName(address): string {
        return address.$Displayname;
    }


    _onSaveButtonClick(): void {
        this.StandbyStart();
        if (this.isDirty) {
            this.RequestManager.callfunction("Webtool_API_TravelBookingForm_SaveData", this.getData(), lang.hitch(this, this._onSaveResponse), lang.hitch(this, this._onSaveError));
        } else {
            console.log(this.getData(), "notDirty");
        }
    }

    private _onSaveResponse(response) {
        this.StandbyStop();
        this.table.activateRowClick();
        this.isDirty = false;
        this.tableIsDirty = false;
        this.emitDirty(this.isDirty);
        this.loadData(response.entityId, this.bookingType);
        this.emit("save");
        if (this.isEmbeddedInTab) {
            this.requestContextButtonDisable("save", this.isDirty);
        }
        this.requestTabRename(this.getTabTitle());
    }

    private _onSaveError(error) {
        this.StandbyStop();
        console.error(error);
    }

    _onCloseRequest() {
        let hasChanged = this.isDirty;
        if (hasChanged) {

            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(
                this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback)
            );
            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result): void {
        if (result == -1) { // nein
            if (this.isEmbeddedInTab) {
                this.closeTab();
            } else {
                this.emit("close");
            }
        } else if (result == 0) { // cancel

        }
        else { //Save
            this._onSaveButtonClick();
            if (this.isEmbeddedInTab) {
                this.closeTab();
            } else {
                this.emit("close");
            }
        }
    }

    private _checkStoreDirty(storeDirty: boolean): void {
        this.tableIsDirty = storeDirty;
        this.isDirty = this.isDirty || this.tableIsDirty;
        this.emitDirty(this.tableIsDirty);
        if (this.isEmbeddedInTab) {
            this.requestContextButtonDisable("save", this.tableIsDirty);
        }
        this.bookedForExpandableSection.setMarking(this.table.hasEntities() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    private _checkDirtyChange(e: Event): void {
        console.trace();
        this.isDirty = true;
        this.table.deactivateRowClick();
        this.emitDirty(this.isDirty);
        if (this.isEmbeddedInTab) {
            this.requestContextButtonDisable("save", this.isDirty);
            this.requestContextButtonDisable("rollback", this.isDirty);
            this.requestContextButtonDisable("locationSwitched", !this.isDirty);
            this.requestContextButtonDisable("location", !this.isDirty);
            this.requestContextButtonDisable("noLocation", !this.isDirty);
        }
    }

    private _resetDirty(): void {
        this.isDirty = false;
        this.tableIsDirty = false;

        this.table.activateRowClick();

        this.emitDirty(this.isDirty);

        if (this.isEmbeddedInTab) {
            this.requestContextButtonDisable("save", this.isDirty);
            this.requestContextButtonDisable("rollback", this.isDirty);
            this.requestContextButtonDisable("locationSwitched", !this.isDirty);
            this.requestContextButtonDisable("location", !this.isDirty);
            this.requestContextButtonDisable("noLocation", !this.isDirty);
        }
    }

    private _onChangeCarrier(e: Event, suppressChangeEvent: boolean = false): void {
        if (this.hintboxCarrier.getValue()) {
            this.disableNode(this.hintboxCarrierContactPerson.domNode, false);
            this.hintboxCarrierContactPerson.addAdditionalRequestParameter("organisation", this.hintboxCarrier.getValue("value"));
        } else {
            this.disableNode(this.hintboxCarrierContactPerson.domNode, true);
            this.hintboxCarrierContactPerson.removeAdditionalRequestParam("organisation");
        }
        if (!suppressChangeEvent) {
            this.onInputChange(e);
        }

    }

    private _onChangeCarrierContactPerson(e: Event, suppressChangeEvent: boolean = false): void {
        //this.newMailFormReciverMail = null;
        //var contactPersonEntity = this.hintboxCarrierContactPerson.getValue("entity");

        //if (contactPersonEntity) {
        //    var contactAdressesses = contactPersonEntity.EL_vt_telecommunications_adress;
        //}

        //if (contactAdressesses) {
        //    for (var i = 0; i < contactAdressesses.length; i++) {
        //        if (contactAdressesses[i].Classname === "email_addresses") {
        //            this.newMailFormReciverMail = contactAdressesses[i].telecom_code;
        //            break;
        //        }
        //    }
        //}

        //if (!suppressChangeEvent) {
        //    this.onInputChange(e);
        //}

    }

    private _getContactPersonMail(hintbox: MdsLax<InstanceType<typeof HintBox>>): string {

        var contactPersonEntity = hintbox.getValue("entity") as AddressWizardTypes.ContactPersonEntity;
        if (contactPersonEntity) {

            var contactAdressesses = contactPersonEntity.EL_vt_telecommunications_adress;

            if (contactAdressesses) {
                for (var i = 0; i < contactAdressesses.length; i++) {
                    if (contactAdressesses[i].Classname === AddressClassnames.email_addresses) {
                        return contactAdressesses[i].telecom_code;
                        break;
                    }
                }
            } else {
            }
        }

        return null;

    }

    private _onClickSendMail(hintbox: MdsLax<InstanceType<typeof HintBox>>, forceIfEmptyMail?: boolean, e?: Event): void {
        if (!this.hasFeature("Email_Editor", "TravelBookingForm_NewMail")) return;

        if (!hintbox.getValue()) {
            this.showToast(this.translate("TravelBookingForm_Error_NoContactPerson"), "fas fa-exclamation-triangle");
            return;
        }

        let mailAddress = this._getContactPersonMail(hintbox);

        if (mailAddress || forceIfEmptyMail === true) {

            this.newMailForm = new emailForm();
            this.newMailForm.show("dlg", null, this.getTabContainerName());

            if (mailAddress) {
                this.newMailForm.addRecipients("to", [{ mailaddress: mailAddress, entityID: null }]);
            }
        } else {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.setSize("smaller");
            dlgConfirm.show(
                this.translate("TravelBookingForm_ConfirmMessage_NoEmail"),
                this.translate("TravelBookingForm_Heading_NoEmail"),
                "",
                "",
                "okcancel",
                lang.hitch(this, this._confirmNoMailCallback, hintbox)
            );
        }
    }

    private _confirmNoMailCallback(hintbox: MdsLax<InstanceType<typeof HintBox>>, response: number): void {
        if (response === 1) {
            this._onClickSendMail(hintbox, true);
        }
    }

    private _onClickOpenAddressSED(mode: string, e: MouseEvent): void {
        var organisation = null;

        if (mode === "contact") {
            organisation = this.hintboxCarrier.getValue("value");
        }

        this.loadSelectEntityDialog(e,
            mode,
            lang.hitch(this, this._onCallbackSED),
            null,
            { organisation: organisation },

        );
    }

    private _onCallbackSED(mode: string, data, items): void {
        items?.forEach((element) => {
            switch (mode) {
                case "carrier":
                    this.hintboxCarrier.setValue(element.entry.data);
                    break;
                case "contact":
                    this.hintboxCarrierContactPerson.setValue(element.entry.data);
                    break;
            }
        });
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.bookedForExpandableSection.setMarking(ExpandableSectionMarkings.hasContent);

        this.disableNode(this.projectEdit.domNode);

        this.on("change", lang.hitch(this, this._checkDirtyChange));

        this.hintboxCarrier.addAdditionalRequestParameter("type", this.bookingType);

        this.SEDconfigCallfunction = "Webtool_API__TravelBookingForm_SED_GetConfig";

        this.hintboxCarrier.addInlineButton(lang.hitch(this, this._onClickOpenAddressSED, "carrier"));
        this.hintboxCarrierContactPerson.addInlineButton(lang.hitch(this, this._onClickOpenAddressSED, "contact", this.hintboxCarrier.getValue("value")));

        if (this.hasFeature("Email_Editor", "TravelBookingForm_NewMail")) {
            this.hintboxCarrier.addInlineButton(lang.hitch(this, this._onClickSendMail, this.hintboxCarrier), "email", "fas fa-at", "Mail");
            this.hintboxCarrierContactPerson.addInlineButton(lang.hitch(this, this._onClickSendMail, this.hintboxCarrierContactPerson), "email", "fas fa-at", "Mail");
        }


        this.disableNode(this.hintboxCarrierContactPerson.domNode, true);





    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this.isEmbeddedInTab) {
            this.createDefaultButton("save", lang.hitch(this, this._onSaveButtonClick), false);
        }


    }
}

mdsLazyProto(TravelBookingForm.prototype, {
  mailDlg: () => (new GenericDialog()),
});
export default mdsWidget(TravelBookingForm);
